module.exports = __webpack_public_path__ + "img/terms-and-conditions.35f41af5.png";